// extracted by mini-css-extract-plugin
module.exports = {"header":"SettingsFakeDoorView_header_3N6do"};